import React from 'react';
import {Modal} from "react-bootstrap";
import {useTranslation, withTranslation} from "react-i18next";
import {connect, DispatchProp} from "react-redux";
import {RootState} from "../../../../reducers";
import {StoreConfigLoyaltyApi} from "../../../services/Api/types";
import IframeWidget from "../../../utils/IframeWidget";
import RoundedIcon from "../../Common/RoundedIcon";
import {ReactComponent as CashbackOutlineIco} from "../../../../images/icons/cashback-outline.svg";


interface OwnProps {
    config_loyalty: StoreConfigLoyaltyApi,
    onHide: () => void,
    onShow?: () => void,
    onClick: () => void
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

function LoyaltyCashbackInfoModalComponent(props: Props) {
    let {t} = useTranslation();

    return (
        <Modal dialogClassName="modal-full" className='small-modal modal-new' show={true}
               onHide={() => IframeWidget.onHide(props.onHide)}
               onShow={() => IframeWidget.onShow(props.onShow)}
        >
            <div>
                <Modal.Header>
                    <button onClick={() => IframeWidget.onHide(props.onHide)} className="btn-close" data-bs-dismiss="modal"
                            aria-label="Close"/>
                </Modal.Header>
            </div>
            <Modal.Body>
                <div className='user-additional-information-modal-body d-flex flex-column align-items-center'>
                    <div className="w-100 d-flex align-items-center justify-content-center mb-3">
                        <RoundedIcon icon={<CashbackOutlineIco className="text-success"/>}/>
                    </div>
                    <h5 className="mb-2">
                        {t("modules.user.field.cashback_program.title")}
                    </h5>
                    <p className="text-center">
                        {t("modules.user.field.cashback_program.description")}
                    </p>
                    {props.config_loyalty.cashback?.info && (
                        <p className="text-center">
                            {props.config_loyalty.cashback?.info}
                        </p>
                    )}
                    <button className={"btn btn-default w-100"} onClick={props.onHide}>
                        {t("modules.user.action.ok.title")}
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

const mapStateToProps = (state: RootState) => ({})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(LoyaltyCashbackInfoModalComponent));
